import { createApp } from 'vue'
import App from './App.vue'
import router from './router';

import './tailwind.css'
import PrimeVue from 'primevue/config';// or another theme of your choice
import 'primeicons/primeicons.css';

const app = createApp(App);

app.use(router);
app.use(PrimeVue);
app.mount('#app')
